import { defineComponent, IOmniaShell, shell } from "../omnia";
import { IAnalysisValueColumn } from "../types";

export class SoilColumnsEditCtrl extends shell.Dialog {


    static createPopup(): ng.IDirective {
        return defineComponent(SoilColumnsEditCtrl, "app/soil/dashboard/columns-popup.html");
    };

    public columnsDefinitions: IAnalysisValueColumn[];
    public max: number;

    static $inject = ["$scope", "OmniaShell"];

    constructor($scope: ng.IScope, shell: IOmniaShell) {
        super($scope, shell);
    }

    $onInit() {
        this.setup()
    }

    get title(): string {
        return "Displayed columns (" + this.visibleColumns + "/" + this.max + ")";
    }

    protected setup() {
        this.columnsDefinitions = this.arguments.columns;
        this.max = this.arguments.max;
    }

    selectAll(value: boolean = true) {
        this.columnsDefinitions.forEach(d => d.visible = value);
    }

    get visibleColumns(): number {
        return this.columnsDefinitions.filter(c => c.visible).length;
    }

    canCheckOthers(): boolean {
        return this.visibleColumns < this.max;
    }

}
